import React, { useState, useEffect, useMemo } from "react";
import "./FeatureTable.scss";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from "../../../config";
import { useNavigate } from "react-router-dom";
import { allAcronyms } from "../../../constants/acronyms";
import { getCassette, getReperti, getArchivio } from "../../../api";
import CustomTooltip from "../../CustomTooltip";
import { useAppContext } from "../../Context/AppContext";
import { ArchiveIcon } from "../../../assets/icons";
import useFetchData from "../../../hooks/useFetchData";

export const FeatureTable = ({ properties }) => {
  const navigate = useNavigate();

  const { layers, setCassetteFilter, setRepertiFilter, setArchivioFilter } = useAppContext();
  const [numberOfCassette, setNumberOfCassette] = useState(0);
  const [numberOfReperti, setNumberOfReperti] = useState(0);


  const layer = properties && properties.layerName ? layers.find((layer) => layer.tipo === properties.layerName) : null;


  const cassetteFilter = layer && [
    { key: "raccolta.provenienza.tipo", value: properties.layerName },
    { key: "raccolta.provenienza.chiave", value: layer.chiave },
    { key: "raccolta.provenienza.valore", value: properties[layer.chiave] },
  ]

    const repertiFilter = layer && [
      { key: "provenienza.tipo", value: properties.layerName },
      { key: "provenienza.chiave", value: layer.chiave },
      { key: "provenienza.valore", value: properties[layer.chiave] },
    ]

    const archivioFilter = useMemo(() => {
      if (!layer) return null;
      return [
        { key: "georeferenziazione.tipo", value: properties.layerName },
        { key: "georeferenziazione.chiave", value: layer.chiave },
        { key: "georeferenziazione.valore", value: properties[layer.chiave] },
      ];
    }, [
      layer?.id,
      layer?.chiave,
      properties?.layerName,
      layer ? properties?.[layer.chiave] : null,
    ]);

  console.log(">>> CASSETTE FILTER: ", cassetteFilter);
  console.log(">>> REPERTI FILTER: ", repertiFilter);
  console.log(">>> ARCHIVIO FILTER: ", archivioFilter);


  const fetchNumberOfCassette = async () => {

    const cassette = await getCassette([
      {key: "page", value: 1}, 
      { key: "pageSize", value: 1 },
      ...cassetteFilter
    ]);
    if(cassette && cassette.totalElements!==null) setNumberOfCassette(cassette.totalElements);
  }

    const fetchNumberOfReperti = async () => {
      const reperti= await getReperti([
        {key: "page", value: 1}, 
        { key: "pageSize", value: 1 },
        ...repertiFilter
      ]);
      if(reperti && reperti.totalElements!==null) setNumberOfReperti(reperti.totalElements);
    }

    const {
      totalRecords: numberOfFascicoli = 0,
    } = useFetchData(getArchivio, archivioFilter);

  
  useEffect(() => {
    if(layer) {
      fetchNumberOfCassette();
      fetchNumberOfReperti();
      }
  }, [properties]);


  const jumpToCassette =  () => {
    setCassetteFilter(cassetteFilter);
    navigate("/cassette");
  }

    const jumpToReperti =  () => {
      setRepertiFilter(repertiFilter);
      navigate("/reperti");
    }

  const jumpToFascicoli =  () => {
    setArchivioFilter(archivioFilter);
    navigate("/archivio");
  }

  // Filter properties based on definitions
  const filteredProperties = {};
  if(properties !== null) Object.keys(properties).forEach((key) => {
    if(allAcronyms[key]){
      filteredProperties[key] = properties[key];
    }
  });

  return (
    <>
      <div className="feature-table-container">
        <table className="feature-table">
          <thead className="feature-table-header">
            <tr>
              <th className="feature-table-header-column">ACRONIMO</th>
              <th className="feature-table-header-description">DEFINIZIONE</th>
              <th className="feature-table-header-column">DATO</th>
            </tr>
          </thead>
          <tbody className="feature-table-body-container">
            {Object.entries(filteredProperties).map(([key, value]) => (
              <tr className="feature-table-data" key={key}>
                <td className="feature-table-body-column">{key}</td>
                <td className="feature-table-body-description">
                  {allAcronyms[key]}
                </td>
                <td className="feature-table-body-column">
                  {value === null ? " " : value}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="db-reference">
          <p>Numero di cassette collegati: <b>{numberOfCassette}</b> </p>
          <CustomTooltip text="Vai alle cassette">
            {numberOfCassette && numberOfCassette > 0 
            ? (<button className="jump-button" onClick={() => jumpToCassette()}><ArchiveIcon fillColor="var(--archeo-color)"/></button>)
            : (<ArchiveIcon filColor="#ccc"/>)}
          </CustomTooltip>
      </div>
      <div className="db-reference">
        <p>Numero di reperti collegati: <b>{numberOfReperti}</b> </p>
        <CustomTooltip text="Vai ai reperti">
          {numberOfReperti && numberOfReperti > 0 
          ? (<button className="jump-button" onClick={() => jumpToReperti()}><ArchiveIcon fillColor="var(--archeo-color)"/></button>)
          : (<ArchiveIcon filColor="#ccc"/>)}
        </CustomTooltip>
      </div>
      <div className="db-reference">
        <p>Numero di fascicoli collegati: <b>{numberOfFascicoli}</b> </p>
        <CustomTooltip text="Vai ai reperti">
          {numberOfFascicoli && numberOfFascicoli > 0 
          ? (<button className="jump-button" onClick={() => jumpToFascicoli()}><ArchiveIcon fillColor="var(--archeo-color)"/></button>)
          : (<ArchiveIcon filColor="#ccc"/>)}
        </CustomTooltip>
      </div>
    </>
  );
};

export default FeatureTable;
